<template>
  <div
    class="main-loader"
    v-if="loading"
  >
    <div class="loader"/>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'MainLoader',
  computed: {
    ...mapGetters('app', ['loading'])
  }
}
</script>
////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
  .main-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 3px;
    .loader {
      width: 20px;
      height: 100%;
      background-color: #c41000;
      animation: kit 5s infinite;
    }
  }

  @keyframes kit {
    0% {
      transform: translateX(0);
      width: 0;
    }
    50% {
      transform: translateX(0);
      width: 100%;
    }
    100% {
      transform: translateX(100vw);
      width: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/main-layout/main-loader.vue